import { render, staticRenderFns } from "./DeliveryStatisticsHead.vue?vue&type=template&id=3e8ecf87&scoped=true"
import script from "./DeliveryStatisticsHead.vue?vue&type=script&lang=js"
export * from "./DeliveryStatisticsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ecf87",
  null
  
)

export default component.exports